import React, { Fragment } from "react"
import { Button, Divider, Form, Input, InputNumber, Progress, Radio, Row, Select, Typography } from "antd";
import { EuroOutlined } from "@ant-design/icons"
import { getCurrencyFormater, getDeviseSymbol } from "../../i18n";
import { t } from "@lingui/core/macro"
import { Trans } from "@lingui/react/macro"

const { Text } = Typography

export default class Caisse extends React.Component {

    state = {
        nbMonth: 12
    }

    render() {
        const { config, context, devise } = this.props

        const caisse = config.caisse

        if (caisse && caisse.withObjectif) {
            var displayTarget = caisse.objectif + caisse.marge
            var displayTotal = caisse.total + caisse.marge
            var displayReste = displayTotal < displayTarget ? displayTarget - displayTotal : 0
            var percent = displayTotal * 100 / displayTarget

            if (caisse.smart) {
                displayTarget = caisse.objectif
                displayReste = parseFloat(caisse.reste).toFixed(2)
                if (caisse.reste > caisse.objectif) {
                    percent = 0
                }
            }
        }

        const currencyFormater = getCurrencyFormater(context)

        return (
            <div style={{ display: "flex", alignItems: "center", flexDirection: "column", padding: "20px 0%" }}>

                <Form.Item
                    label={t`Montant`}
                    name="montant"
                    rules={[{ required: true, message: t`Ce champ est obligatoire` }]}
                >
                    <InputNumber
                        size="large"
                        min={1}
                        placeholder={t`Montant`}
                        addonAfter={getDeviseSymbol(context, devise)}
                    />
                </Form.Item>

                {(config.caisse && config.caisse.withObjectif) && (
                    <div style={{ marginBottom: 20, width: "80%" }}>
                        <Row justify={"space-between"}>
                            <Text>
                                <Trans>Objectif :</Trans> {currencyFormater(displayTarget, 0, devise)}
                            </Text>
                            <Text>
                                <Trans>Reste :</Trans> {currencyFormater(displayReste, 0, devise)}
                            </Text>
                        </Row>

                        <Progress
                            percent={parseInt(percent)}
                            status="active"
                            strokeColor={{
                                from: '#833ab4',
                                to: '#c53cd4',
                            }}
                        />
                    </div>
                )}

                <Form.Item label={t`Je donne :`} name="abo">
                    <Radio.Group optionType="button" buttonStyle="solid">
                        <Radio value={false}><Trans>Une fois</Trans></Radio>
                        <Radio value={true}><Trans>Tous les mois</Trans></Radio>
                    </Radio.Group>
                </Form.Item>

                <Form.Item noStyle shouldUpdate>
                    {(e) => {
                        if (!e.getFieldValue("abo")) {
                            return null
                        }

                        const value = e.getFieldValue("nbMonth")
                        const montant = e.getFieldValue("montant")

                        return (
                            <Fragment>
                                <select disabled={this.props.disabled}
                                    className={"form-control"}
                                    value={value}
                                    onChange={(v) => e.setFieldValue("nbMonth", v.target.value)}
                                >
                                    <option value={0}>
                                        <Trans>En continue - résiliable à tout moment</Trans>
                                    </option>
                                    {Array.from(Array(35).keys()).map((i) => {
                                        return (
                                            <option value={i + 2}>
                                                {t`pendant ${i + 2} mois`}
                                            </option>
                                        )
                                    }).reverse()}
                                </select>

                                {value > 0 && (
                                    <div style={{ marginTop: 15, textAlign: "center" }}>
                                        <Text>
                                            <Trans>Soit un total de :</Trans>{" "}
                                            <b>{currencyFormater(parseFloat(montant * value), 0, devise)}{getDeviseSymbol(context, devise)}</b>
                                        </Text>
                                    </div>
                                )}
                            </Fragment>
                        )
                    }}
                </Form.Item>

            </div>
        )
    }
}
